import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import {
  getActivities,
  getActivityCategories,
} from '../../Activity/store/actions'
import { Spinner } from '../../App/Components'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'

import { EditSurvey } from './screens/crud/EditSurvey'
import { PreviewSurvey } from './screens/crud/PreviewSurvey'
import { SurveyStats } from './screens/crud/SurveyStats'
import { SurveyOverview } from './screens/SurveyOverview'
import { getSurveys } from './Store/Action'

export const SurveyBootstrap = () => {
  const establishmentId = useAppSelector(
    state => state.establishment.active?.id,
  )
  const surveys = useAppSelector(state => state.customers.surveys)

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (
      surveys.list.length === 0 &&
      surveys.isLoading === false &&
      surveys.error === false
    ) {
      dispatch(getSurveys())
      dispatch(getActivityCategories())
      dispatch(getActivities())
    }
  }, [surveys.list.length])

  if (
    typeof establishmentId === 'undefined' ||
    (surveys.list.length < 1 && surveys.isLoading)
  ) {
    return <Spinner />
  }

  return (
    <Switch>
      <Route
        path="/customers/surveys/:surveyId/preview"
        component={PreviewSurvey}
      />
      <Route path="/customers/surveys/:surveyId/edit" component={EditSurvey} />
      <Route
        path="/customers/surveys/:surveyId/stats"
        component={SurveyStats}
      />
      <Route path="/customers/surveys" component={SurveyOverview} />
    </Switch>
  )
}
